<div class="field-wrapper">
  <div *ngIf="label">
    <span class="field-label">{{ label }}</span>
    <span
      *ngIf="required"
      class="text-primary"
      >*</span
    >
  </div>

  <div class="mt-2">
    <ng-otp-input
      class="field-otp"
      (onInputChange)="onInputChange($event)"
      [config]="config"
    ></ng-otp-input>
  </div>

  <div class="block text-xs text-primary mt-1">
    <ng-content select="mat-error"></ng-content>
  </div>
</div>
